function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1013",
  "data-name": "Group 1013",
  transform: "translate(-24.463 -398.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_750",
  "data-name": "Path 750",
  d: "M2.25-2.25h20",
  transform: "translate(22.713 422.057)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144h4",
  transform: "translate(13.955 468.145)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_748",
  "data-name": "Path 748",
  d: "M23.732-57.856a1.058,1.058,0,0,0-.267-.71.87.87,0,0,0-.644-.294H8.646a.873.873,0,0,0-.646.3,1.062,1.062,0,0,0-.268.712v18.038h16Z",
  transform: "translate(19.074 459.637)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_749",
  "data-name": "Path 749",
  d: "M18.456-64.144h8",
  transform: "translate(12.545 463.145)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1012",
  "data-name": "Group 1012",
  transform: "translate(0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1011",
  "data-name": "Group 1011"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1009",
  "data-name": "Group 1009"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_57",
  "data-name": "Line 57",
  x2: 12,
  transform: "translate(28.5 411.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_65",
  "data-name": "Line 65",
  x2: 12,
  transform: "translate(28.5 409.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  x2: 12,
  transform: "translate(28.5 413.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_59",
  "data-name": "Line 59",
  x2: 12,
  transform: "translate(28.5 415.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_60",
  "data-name": "Line 60",
  x2: 12,
  transform: "translate(28.5 417.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1008",
  "data-name": "Group 1008",
  transform: "translate(485 251) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61",
  "data-name": "Line 61",
  x2: 8,
  transform: "translate(158.5 450.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62",
  "data-name": "Line 62",
  x2: 8,
  transform: "translate(158.5 452.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63",
  "data-name": "Line 63",
  x2: 8,
  transform: "translate(158.5 454.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64",
  "data-name": "Line 64",
  x2: 8,
  transform: "translate(158.5 456.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1010",
  "data-name": "Group 1010",
  transform: "translate(491.5 251) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61-2",
  "data-name": "Line 61",
  x2: 8,
  transform: "translate(158.5 450.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62-2",
  "data-name": "Line 62",
  x2: 8,
  transform: "translate(158.5 452.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63-2",
  "data-name": "Line 63",
  x2: 8,
  transform: "translate(158.5 454.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64-2",
  "data-name": "Line 64",
  x2: 8,
  transform: "translate(158.5 456.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-23.1h5v-2.636h-5Z",
  transform: "translate(9.855 429.647)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgUnits = function SvgUnits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21.822,
    viewBox: "0 0 21 21.822",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/units.e3448b0a.svg";
export { ForwardRef as ReactComponent };